<proffeo-ui-dialog [title]="'files.explorer.external-edit' | translate">
  <form (submit)="save($event)">
    <p class="text-proffeo-muted text-sm">{{ 'files.explorer.external-help' | translate }}</p>
    <proffeo-ui-input
      [formField]="linkForm.url"
      label="files.explorer.external-url"
    />
    <p class="text-proffeo-muted text-sm">{{ 'files.explorer.external-clear' | translate }}</p>
  </form>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      text="close"
      matDialogClose
    />
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="linkForm().invalid()"
      text="save-and-close"
      variant="accent"
    />
  </div>
</proffeo-ui-dialog>
